import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductModel } from 'src/app/models/product.model';
import { ProfileModel } from 'src/app/models/profile.model';

@Component({
  selector: 'product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.scss'],
})
export class ProductViewComponent implements OnInit {
  @Input()
  item:ProductModel;

  @Input()
  producer:ProfileModel;

  @Input()
  priceMode: string;

  @Input()
  countryCode: string;

  constructor(public route:ActivatedRoute,) {
    this.route.data
      .subscribe((data) => {
        if(data.product){
          this.item = data.product;
        }
        if(data.producer){
          this.producer = data.producer;
        }
      });
  }

  ngOnInit() {
  }
  
}
